import {
  Briefcase,
  Calculator,
  Gavel,
  Landmark,
  Languages,
  Ruler,
  Scale,
  Stamp,
  type LucideIcon,
} from "lucide-react";

/**
 * The icons a profession may be given (spec 8a948f97, RES-3).
 *
 * A CURATED ALLOWLIST, not a free-text name. Icons are React components, so an
 * admin cannot supply one; what an admin can do is choose from a list someone
 * vetted. Resolving an arbitrary string dynamically would turn a typo into a
 * blank card and pull the whole icon set into the bundle.
 *
 * THE COST, named rather than hidden: adding a NEW icon here stays a code
 * change. That is acceptable while professions arrive a few times a year. If
 * they start arriving monthly, an uploaded and sanitised SVG is the better
 * shape — recorded as spec residue rather than designed now.
 */
export const PROFESSION_ICONS: Record<string, LucideIcon> = {
  stamp: Stamp,
  scale: Scale,
  calculator: Calculator,
  languages: Languages,
  gavel: Gavel,
  landmark: Landmark,
  ruler: Ruler,
};

/**
 * What a profession with no icon chosen renders.
 *
 * DELIBERATELY NOT IN THE ALLOWLIST ABOVE. It was, and that put a "Maletín"
 * option in the picker drawing exactly the same glyph as "Genérico" — two
 * entries, one picture, no way to tell which you had chosen.
 */
export const NeutralProfessionIcon: LucideIcon = Briefcase;

export const PROFESSION_ICON_KEYS = Object.keys(PROFESSION_ICONS);

/**
 * Never null, so a card always renders.
 *
 * A profession registered before anyone picked an icon is a normal state, not
 * an error — the neutral briefcase is what it gets.
 */
export function professionIcon(iconKey: string | null | undefined): LucideIcon {
  return (iconKey && PROFESSION_ICONS[iconKey]) || NeutralProfessionIcon;
}
